import type { FunctionComponent } from 'react'

import { FlowPage } from '@monthio/design-system'

import { ConfirmationScreenIcon } from './ConfirmationScreenIcon'

export interface ConfirmationScreenProps {
	text: string
}

export const ConfirmationScreen: FunctionComponent<ConfirmationScreenProps> = ({
	text,
}) => {
	return (
		<FlowPage>
			<FlowPage.Content $isCentered $spacing="xs">
				<FlowPage.Header title={text} slot={<ConfirmationScreenIcon />} />
			</FlowPage.Content>
		</FlowPage>
	)
}
